export interface ConfirmationOptions {
  title: string;
  description: string;
  confirmLabel?: string;
  cancelLabel?: string;
}

export interface ConfirmationRequest extends ConfirmationOptions {
  id: number;
  resolve: (confirmed: boolean) => void;
}

export type ConfirmationQueueAction =
  | { type: 'enqueue'; request: ConfirmationRequest }
  | { type: 'settle'; id: number };

export function confirmationQueueReducer(
  state: ConfirmationRequest[],
  action: ConfirmationQueueAction,
): ConfirmationRequest[] {
  if (action.type === 'enqueue') return [...state, action.request];
  if (state[0]?.id !== action.id) return state;
  return state.slice(1);
}
